import styled from 'styled-components'

import { ModalSubmitButtonUnstyled } from 'Components/Form/ModalSubmitButton/unstyled'

export const ModalSubmitButton = styled(ModalSubmitButtonUnstyled)`
  display: block;
  float: right;
  height: 50px;
  padding: 0 30px;
  line-height: 50px;
  background: ${props => props.theme.colors.primary};
  color: ${props => props.theme.colors.white};
  border-radius: 4px;
  font-size: ${props => props.theme.fontSizes.modal.modalButton};
  font-family: ${props => props.theme.fonts.robotoMedium};
  cursor: pointer;
`



// WEBPACK FOOTER //
// ./src/Components/Form/ModalSubmitButton/index.js